import React from 'react';
import { colors } from '../constants';

const ExclamationWarningIcon = ({ color = colors.aroYellowDark, size = '40' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height={`${size}px`}
        viewBox="0 -960 960 960"
        width={`${size}px`}
    >
        <path d="M40-120 480-880 920-120H40Z" fill={color} />
        <rect x="440" y="-560" width="80" height="200" fill="white" />
        <circle cx="480" cy="-235" r="40" fill="white" />
    </svg>
);

export default ExclamationWarningIcon;
